var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcono(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.165,
    height: 16.258,
    viewBox: "0 0 22.165 16.258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-278.809 -809.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.665,23.758H3.484a.987.987,0,0,1-.984-.984V8.5H22.68a.987.987,0,0,1,.984.984Z",
    transform: "translate(276.809 801.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7,17l7.851,6L22.7,17",
    transform: "translate(275.137 797.445)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcono);
export default __webpack_public_path__ + "static/media/mail_icono.b3182066a88889064b5c89ba506a10b7.svg";
export { ForwardRef as ReactComponent };